module.exports = __webpack_public_path__ + "img/arrow-bold-reply.81c18c5f.svg";